module.exports = __webpack_public_path__ + "img/20191209_111827(0)-1.8aa9c7c4.jpg";